import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {Container as Wrapper} from 'components/InputTitle';

export type InputDescriptionProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Container = styled(Wrapper)`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  
  padding: 10px 14px;

  &::placeholder {
    color: ${({theme}) => `
      ${transparentize(.7, theme.variables.color)};
    `};
  }
`;

/**
 * The input description component
 * @param {InputDescriptionProps} props
 * @return {React.ReactElement<InputDescriptionProps>}
 * @constructor
 */
export default function InputDescription(
    props: InputDescriptionProps,
): React.ReactElement<InputDescriptionProps> {
  return <Container {...props} />;
}
